// Where a visitor belongs when they land somewhere with nothing for them. A stored session token
// counts as signed in: if it has expired, the dashboard's PrivateRoute finds out, clears it and
// sends them back to sign-in, so this can't loop.
export const SIGNED_IN_HOME = "/dashboard";
export const SIGN_IN_PATH = "/authentication/sign-in";

function hasSession(storage) {
  try {
    return !!storage.getItem("adminToken");
  } catch {
    return false;
  }
}

// Unknown addresses (and "/"): the dashboard when signed in, otherwise the sign-in page.
export function fallbackPath(storage = window.localStorage) {
  return hasSession(storage) ? SIGNED_IN_HOME : SIGN_IN_PATH;
}

// The sign-in page itself: a signed-in visitor is sent to the dashboard (returns its path), but
// never while the page is finishing an SSO round-trip (?token=) or showing an error (?error=).
export function signInRedirect(searchParams, storage = window.localStorage) {
  if (searchParams.get("token") || searchParams.get("error")) return null;
  return hasSession(storage) ? SIGNED_IN_HOME : null;
}
